export const FETCH_CITIES_REQUESTED = 'FETCH_CITIES_REQUESTED';
export const FETCH_CITIES_RECEIVED = 'FETCH_CITIES_RECEIVED';
export const SELECT_CITY = 'SELECT_CITY';
